import React from 'react';
import scaleSize from '../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(30)}
    height={scaleSize(26)}
    viewBox="0 0 30 26"
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#9F9F9F"
        fillRule="nonzero"
        d="M28 0a2 2 0 0 1 2 2v16.5a1.5 1.5 0 0 1-3 0V3H7.5a1.5 1.5 0 0 1 0-3H28z"
      />
      <path
        stroke="#9F9F9F"
        strokeWidth="3"
        d="M2 7.5a.5.5 0 0 0-.5.5v16a.5.5 0 0 0 .5.5h20a.5.5 0 0 0 .5-.5V8a.5.5 0 0 0-.5-.5H2z"
      />
    </g>
  </svg>
);
